// Los tres documentos de la entrega final. `key` es lo que viaja a la API como
// `?document=` (y el nombre del archivo en el storage); `dateField` es la
// columna del grupo con la fecha de subida, null si todavia no se subio.
// La entrega esta completa cuando estan los tres: ahi el backend escribe
// `final_report_date`.
export const FINAL_DOCUMENTS = [
  {
    key: "informe-final",
    label: "Informe final",
    dateField: "final_report_uploaded_at",
    fileName: "InformeFinal",
  },
  {
    key: "long-paper",
    label: "Long paper",
    dateField: "long_paper_uploaded_at",
    fileName: "LongPaper",
  },
  {
    key: "ficha-ejecutiva",
    label: "Ficha ejecutiva",
    dateField: "executive_summary_uploaded_at",
    fileName: "FichaEjecutiva",
  },
];

export const missingFinalDocuments = (group) =>
  FINAL_DOCUMENTS.filter((document) => !group?.[document.dateField]);
